/* eslint-disable class-methods-use-this */
import { GpsType } from '../../../../../../../global/components/layout/layout-models';
import { LayDcPlanAdoptionContentModel } from '../../models/plan-adoption-form-models';
import { GetAmendLayDcFormContentModel } from '../plan-amend-helper';
import { LayDcAdoptionDetailsWizard } from './lay-dc-adoption-details-wizard';

export class LayDcAmendDetailsWizard extends LayDcAdoptionDetailsWizard {

    isIndemnificationRequired(): boolean {
        return false;
    }

    getFormContentModel(): LayDcPlanAdoptionContentModel {

        const institutionSettings = this.epiContent?.institutionSettingsState?.epiContent;
        const content = super.getFormContentModel();
        const amendCommonFormContentModel = GetAmendLayDcFormContentModel(content, institutionSettings);

        return {
            ...amendCommonFormContentModel,
            gpsType: GpsType.LayDcAmendDetail,            
            pageTitle: institutionSettings?.amendLayDCDetailsTitle,
            PageDescription: institutionSettings?.amendLayDCDetailsDescription,
        };
    }
}